export default class ScrollAnimate {
  constructor() {
    this.lastScroll = window.scrollY
    this.initObserver()
    this.init()
  }

  initObserver() {
    const { rootMargin, threshold } = this.getDynamicRootMargin()
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-up')
        }
      })
    }, {
      rootMargin: rootMargin,
      threshold: threshold
    })
  }

  init() {
    const elements = document.querySelectorAll('.fade-in-element')
    elements.forEach((el, index) => {
      if (this.isElementInExtendedViewport(el)) {
        setTimeout(() => {
          el.classList.add('fade-in-left')
        }, index * 100)
      } else {
        this.observer.observe(el)
      }
    })
  }

  getDynamicRootMargin() {
    const currentScroll = window.scrollY
    const isFirstElement = document.body.scrollTop === 0 // ページの最上部にいるかチェック
    if (this.lastScroll > currentScroll) {
      // 上にスクロールしている場合
      this.lastScroll = currentScroll
      return { rootMargin: isFirstElement ? '0px 0px 0px 0px' : `-${window.innerHeight * 0.75}px 0px 0px 0px`, threshold: 1 }
    } else {
      // 下にスクロールしている場合
      this.lastScroll = currentScroll
      return { rootMargin: isFirstElement ? '0px 0px 0px 0px' : `-${window.innerHeight * 0.75}px 0px 0px 0px`, threshold: 0.01 }
    }
  }

  isElementInExtendedViewport(el) {
    const rect = el.getBoundingClientRect()
    let extendedHeight = window.innerHeight * 1.5 // 画面の高さの150%
    if (document.querySelector('.hero')) {
      extendedHeight = window.innerHeight // 画面の高さの100%
    }
    return (
      rect.top >= -window.innerHeight * 0.25 &&
      rect.left >= 0 &&
      rect.bottom <= extendedHeight &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }
}
